if (!customElements.get("ona-video-modal-button")) {
  class OnaVideoModalButton extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });
      const templateId = "video-modal-button-template";
      let template = document.getElementById(templateId);
      if (!template) {
        template = document.createElement("template");
        template.id = templateId;
        template.innerHTML = `
          <style>
            :host {
              display: flex;
            }

            .default-play-button {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              background: rgba(0, 0, 0, 0.6);
              color: white;
              border: none;
              border-radius: 50%;
              width: 64px;
              height: 64px;
              font-size: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .modal {
              position: fixed;
              top: 0;
              left: 0;
              width: 100vw;
              height: 100vh;
              background: rgba(0, 0, 0, 0.8);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 9999;
              opacity: 0;
              pointer-events: none;
              transition: opacity 0.3s ease;
            }

            .modal[open] {
              opacity: 1;
              pointer-events: auto;
            }

            .modal video,
            .modal iframe {
              max-width: 90vw;
              max-height: 90vh;
            }

            .close-button {
              position: absolute;
              top: 1rem;
              right: 1rem;
              background: none;
              color: white;
              font-size: 2rem;
              border: none;
              cursor: pointer;
            }

            .play-button {
              background: transparent;
              border: none;
              appearance: none;
            }
          </style>
          <button class="play-button" part="play-button" aria-label="Play video">
            <slot name="play-button-content">
              <span class="default-play-button" aria-hidden="true">\u25B6</span>
            </slot>
          </button>
          <div class="modal" part="modal" role="dialog" aria-modal="true" aria-label="Video dialog" tabindex="-1">
            <button class="close-button" part="modal-close-button" aria-label="Close video">&times;</button>
            <div part="modal-content"></div>
          </div>
        `;
        document.body.appendChild(template);
      }
      this.shadowRoot.appendChild(template.content.cloneNode(true));
      this._playButton = this.shadowRoot.querySelector('[part="play-button"]');
      this._modal = this.shadowRoot.querySelector('[part="modal"]');
      this._modalCloseButton = this.shadowRoot.querySelector('[part="modal-close-button"]');
      this._modalContent = this.shadowRoot.querySelector('[part="modal-content"]');
      this._videoLoaded = false;
    }
    connectedCallback() {
      this._playButton.addEventListener("click", this._openModal.bind(this));
      this._modalCloseButton.addEventListener("click", this._closeModal.bind(this));
      document.addEventListener("keydown", this._handleEscape.bind(this));
    }
    disconnectedCallback() {
      document.removeEventListener("keydown", this._handleEscape.bind(this));
    }
    _handleEscape(e) {
      if (e.key === "Escape") {
        this._closeModal();
      }
    }
    _openModal() {
      if (!this._videoLoaded) {
        const src = this.getAttribute("src");
        const el = document.createElement("ona-video");
        el.setAttribute("src", src);
        el.setAttribute("part", "modal-video");
        el.setAttribute("autoplay", "");
        this._modalContent.appendChild(el);
        this._videoLoaded = true;
      }
      this._modal.setAttribute("open", "");
      this._modal.focus();
      document.body.setAttribute("data-video-modal-open", "true");
    }
    _closeModal() {
      this._modal.removeAttribute("open");
      this._modalContent.innerHTML = "";
      this._videoLoaded = false;
      document.body.removeAttribute("data-video-modal-open");
    }
  }
  customElements.define("ona-video-modal-button", OnaVideoModalButton);
}
